import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { IFechRequest } from "interfaces/fetch-duck";
import { requestErrorHandler } from "utils";
import { FetchDocumentCategoryActions } from "store/ducks/settings/document-category";

export function* fetchDocumentCategoryRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiGeneral.get, `/document-category/${id}`);

    yield put(FetchDocumentCategoryActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchDocumentCategoryActions.failure(errorMessage));
  }
}
